/* eslint no-console: "off",  */

import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

export default class CallbackPage extends React.Component {
  static propTypes = {
    authClient: PropTypes.object
  };

  constructor(props) {
    super(props);
    const self = this;

    self.state = {
      validated: null,
      accessToken: ''
    };

    self.parseHash();
  }

  parseHash() {
    const self = this;
    self.props.authClient
      .getAuth()
      .then(result => {
        if (result) {
          console.log('Got Access Token: ' + result);

          self.setState({
            validated: true,
            accessToken: result
          });
        }
      })
      .catch(err => {
        console.error('Failed to get token', err);
        self.setState({
          validated: false,
          accessToken: ''
        });
      });
  }

  render() {
    const self = this;
    return (
      <div>
        {self.state.validated ? (
          <Redirect
            to={{
              pathname: '/dealership-list',
              state: {
                accessToken: self.state.accessToken
              }
            }}
          />
        ) : self.state.validated === null ? (
          <h4>Logging In</h4>
        ) : (
          <h4>Error logging in</h4>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/CallbackPage.js